
export function video($, basicLightbox) {
	// VIDEO
	function videoScript() {
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	function loadVideo() {

		window.onYouTubeIframeAPIReady = function() {
			$('body').trigger('wildoom:youtubeready');
		};

		// PLAYER
		var player;

		window.moduleVideosInit = function(){

			var $mPlayer = $('.js--videoplayer').find('.js--videoplayer--content');
			$mPlayer.attr('id','player');
			var $mPreview = $('.js--videoplayer--preview');
			var videoId = $mPlayer.attr('data-videoid');

			if ($mPreview.length) {
				$mPreview.removeClass('empty').css('background-image', 'url(http://img.youtube.com/vi/'+videoId+'/hqdefault.jpg)');
			}


      const instance = basicLightbox.create('<iframe src="https://www.youtube.com/embed/'+videoId+'" width="560" height="315" frameborder="0"></iframe>')

      $('.js--play-video').click(function(e) {
        e.preventDefault();
        instance.show();
      });


			function onPlayerReady(event) {
				event.target.pauseVideo();
				$('.js--play-video').click(function(e) {
					e.preventDefault();
					event.target.playVideo();
					event.target.unMute();
					$('body').addClass('playing');
				});
			}

			function onPlayerStateChange(event) {
				// Paused
				if (event.data === 2) {
					//$('body').removeClass('playing');
				}
			}

			/*player = new YT.Player('player', {
				height: '100%',
				width: '100%',
				videoId: videoId,
				playerVars: {
					'autoplay': 0,
					'loop': 1,
					'rel': 0,
					'showinfo': 0,
					'playlist': videoId,
					'controls': 0
				},
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});*/

		};

		$('body').on('wildoom:youtubeready', function(){
			window.moduleVideosInit();
			$(document).ajaxComplete(function() {
				window.moduleVideosInit();
			});
		});

	}


	if ($('.js--videoplayer').length) {
		videoScript();
		loadVideo();
	}


}
